import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Col, Row, message, Upload, Image } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";

function AddPadadhikari(props) {
  const [messageApi, contextHolder] = message.useMessage();
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/admin/padadhikari",
    null,
    API_METHODS.POST,
    true
  );
  const [editResponse, editRequest] = useApi(
    `/admin/padadhikari/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT,
    true
  );

  useEffect(() => {
    if (response.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Padadhikari added successfully.",
      });
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Padadhikari updated successfully.",
      });
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      const { image, ...rest } = selectedRecord;
      form.setFieldsValue(rest);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const formData = new FormData();
        for (const key in values) {
          if (key !== "image") {
            formData.append(key, values[key]);
          } else if (values[key]?.file?.originFileObj) {
            formData.append("image", values[key].file.originFileObj, values[key].file.name);
          }
        }
        if (selectedRecord) {
          editRequest(formData);
        } else {
          request(formData);
        }
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    close();
  };

  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleChange = ({ fileList: newFileList }) => {
    const lastFile = newFileList.slice(-1);
    setFileList(lastFile);
  };

  return (
    <Modal
      title={selectedRecord ? "Update Padadhikari" : "Add Padadhikari"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      {contextHolder}
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: "Name is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="post"
              label="Post"
              rules={[{ required: true, message: "Post is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="vibhag"
              label="Vibhag"
              rules={[{ required: true, message: "Vibhag is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="mobile"
              label="Mobile"
              rules={[{ required: true, message: "Mobile is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: "Email is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            {selectedRecord?.image && (
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>Current Image</div>
                <Image src={selectedRecord.image} height={80} style={{ borderRadius: 4 }} />
              </div>
            )}
            <Form.Item
              name="image"
              label={selectedRecord ? "Change Image (optional)" : "Upload Image"}
              rules={selectedRecord ? [] : [{ required: true, message: "Image is required." }]}
            >
              <Upload
                customRequest={dummyRequest}
                listType="picture-card"
                fileList={fileList}
                onChange={handleChange}
                maxCount={1}
                showUploadList={{ showPreviewIcon: true }}
              >
                {fileList.length < 1 && "+ Upload"}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddPadadhikari;
